import VerifySlide from "./verifySlide";
import "./index.css";

type Props = {
  verifyCheckEnd: (e: any) => void;
  // [propName: string]:any
};

const Verify: React.FC<Props> = (props: Props) => {
  const { verifyCheckEnd } = props;
  return (
    <div className="siderEmbed">
      <VerifySlide verifyCheckEnd={verifyCheckEnd} />
    </div>
  );
};

export default Verify;
